import md5 from "md5";
// const keyMpadding = {
//   development: "p*Tp*NI#TS",
//   testing: "p*Tp*NI#TS",
//   production: "p*Tp*NI#TS",
// };
const keyMpadding = {
  development: "p*Tp*NI#TS",
  testing: "v*Tp#NI*TS",
  production: "p*Tp*NI#TS",
};
export const md5SignEncode = (str, env) => {
  return md5(
    `${str}&key=${
      keyMpadding[env || process.env.NODE_ENV] || keyMpadding.development
    }`
  );
};
export const getPosType = () => {
  var agent = navigator.userAgent.toLowerCase();
  console.log(agent);
  // var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (agent.indexOf("windows") >= 0 || agent.indexOf("wow32") >= 0) {
    console.log("这是windows系统");
  }
  if (agent.indexOf("mac") >= 0 || agent.indexOf("wow64") >= 0) {
    console.log("这是mac系统");
  }
  if (agent.indexOf("iphone") >= 0 || agent.indexOf("wow64") >= 0) {
    console.log("这是iphone系统");
  }
  if (agent.indexOf("android") >= 0 || agent.indexOf("wow64") >= 0) {
    console.log("这是android系统");
  }
  // if (isMac) {
  //   console.log("这是mac系统");
  // }
};

// ========================= wjj到此一游 ==================================
// 邮箱还是手机的判断
export const mobileEmailDetection = (phoneAndEmal) => {
  let filg = "";
  if (phoneAndEmal.includes("@")) {
    filg = "2";
  } else {
    filg = "1";
  }
  return filg;
};
function getDeviceId() {
  let id = localStorage.getItem("random_device_id");

  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("random_device_id", id);
  }

  return id;
}
// 获取手机型号等信息
export const equipment = () => {
  const userAgentStr = navigator.userAgent;
  console.log(userAgentStr);
  let deviceName = "";
  let deviceVersion = "";
  let deviceId = "";
  let browser = "";
  let browserVersion = "";
  let flag = userAgentStr.match(
    /Mac|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows/i
  );
  deviceName = flag[0];
  console.log(deviceName);
  if (deviceName === "Windows") {
    deviceVersion = userAgentStr.split("Windows NT ")[1].split(";")[0];
  } else if (deviceName === "Mac") {
    deviceVersion = userAgentStr.split("Mac OS X ")[1].split(")")[0];
  } else if (deviceName === "iPhone") {
    deviceVersion = userAgentStr.split("iPhone OS ")[1].split(" ")[0];
  } else if (deviceName === "iPad") {
    deviceVersion = userAgentStr.split("iPad; CPU OS ")[1].split(" ")[0];
  } else if (deviceName === "Android") {
    deviceVersion = userAgentStr.split("Android ")[1].split(";")[0];
  }
  // 判断浏览器的版本
    // edg
  if (/Edg/.test(userAgentStr)) {
    browserVersion = userAgentStr.match(/Edg\/([\d.]+)/)[1];
    browser = "Edge";
  }

  // 谷歌
  else if (/Chrome/.test(userAgentStr)) {
    browserVersion = userAgentStr.match(/Chrome\/([\d.]+)/)[1];
    browser = "Chrome";
  }

  // 火狐
  else if (/Firefox/.test(userAgentStr)) {
    browserVersion = userAgentStr.match(/Firefox\/([\d.]+)/)[1];
    browser = "Firefox";
  }

  // 苹果
  else if (/Safari/.test(userAgentStr)) {
    browserVersion = userAgentStr.match(/Version\/([\d.]+)/)[1];
    browser = "Safari";
  } 
  // IE
  else if (/Trident/.test(userAgentStr)) {
    const tridentVersionMatch = userAgentStr.match(/Trident\/([\d.]+)/);
    if (tridentVersionMatch) {
      const ieVersion = parseInt(tridentVersionMatch[1]) + 4;
      browserVersion = ieVersion.toString();
      browser = "IE";
    }
  }
  else {
    const match = userAgentStr.match(/Version\/([\d.]+)/);
    if(match){
      browserVersion = match[1];
    }else{
      browserVersion = "otherVersion";
    }
    browser = "other";
  }

  deviceId = md5(deviceName + deviceVersion + browser + browserVersion + getDeviceId());

  return {
    deviceId,
    deviceName,
  };
};
